<template>
  <van-cell class="form-item-table-cell">
    <template slot="title">
      <div
        class="title"
        :class="{'readonly-field-label': isReadOnly}"
        style="display: flex; justify-content: space-between; align-items: center; padding: 10px 16px;">
        <div>
          {{current.title}}
        </div>
        <van-icon v-if="actions.length" name="more" color="#4260FA" size="20px" @click="showHandle = true"/>
      </div>

      <van-action-sheet
        v-model="showHandle"
        :actions="actions"
        cancel-text="取消"
        close-on-click-action
        get-container="body"
        @select="handleSelect"
      />
      <van-popup
        class="table-data-select-popup"
        v-model="showData"
        position="bottom"
        get-container="body"
        close-on-popstate
        :close-on-click-overlay="false"
        :style="{ height: '95%' }">
        <div class="table-data-select-container">
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoad">
            <div class="preview-container">
              <van-checkbox v-model="allSelect" @change="allSelectChange">全选</van-checkbox>
              <van-checkbox-group
                v-model="selectList"
                ref="checkboxGroup">
                <van-checkbox
                  v-for="item in dataList"
                  :key="item.uniqueKey"
                  :name="item.uniqueKey">
                  {{item.value}}
                </van-checkbox>
              </van-checkbox-group>
            </div>
          </van-list>
        </div>
        <div class="footer-handle-container">
          <div style="color: #2d8cf0; font-size: 12px;margin-right: 10px;">已选择{{selectList.length}}条数据</div>
          <van-button type="default" @click="selectCancel">取消</van-button>
          <van-button type="primary" @click="selectConfirm">确定</van-button>
        </div>
      </van-popup>
    </template>
    <template slot="label">
      <div
        v-if="current.fieldHint"
        class="ql-editor"
        v-html="current.fieldHint">
      </div>
      <div v-if="!isRead || (isRead && current.showTableStyle === 'NO')">
        <TableItem
          v-for="(row, idx) in current.value"
          :key="row.id"
          :index="idx"
          :header="current.children"
          :length="length"
          @removeItem="removeItem"
          :isRead="isReadOnly || isRead"
          :show-list="showList"
          :row="row"
          :status="type"
          :current="current"
          :controlChange="controlChange">
        </TableItem>
      </div>
      <div v-if="isRead && current.showTableStyle === 'YES'">
        <ScrollTable
          v-if="subTableData.xList && subTableData.xList.length"
          :y-list="subTableData.yList"
          :x-field="subTableData.xField"
          :x-list="subTableData.xList"
          :width-info="subTableData.widthInfo"
        ></ScrollTable>
      </div>
      <!--      <div v-if="!isRead">-->
      <!--        <TableItem-->
      <!--          v-for="(row, idx) in current.value"-->
      <!--          :key="row.id"-->
      <!--          :index="idx"-->
      <!--          :header="current.children"-->
      <!--          :length="length"-->
      <!--          @removeItem="removeItem"-->
      <!--          :show-list="showList"-->
      <!--          :row="row">-->
      <!--        </TableItem>-->
      <!--      </div>-->
      <br v-if="!isRead">
      <van-button
        v-if="!isRead && !isReadOnly && !current.closeTableCreate"
        color="#4260FA"
        size="small"
        icon="plus"
        @click="addItem"
        block>
        添加
      </van-button>
      <br v-if="!isRead">

      <create-form-apply
        v-if="current.openTableCreate === 'YES'"
        :key="current.dataId"
        ref="tableCreateFormApply"
        :appId="current.startFormInfo.appId"
        :formId="current.startFormInfo.formId"
        :needButton="false"
        :reqDefaultSubmitData="false"
        @formSetFinalComplete="createFormComplete">
      </create-form-apply>

      <!--子表单发起表单，选择数据-->
      <van-popup
        class="table-data-select-popup"
        v-model="showSelectValues"
        position="bottom"
        get-container="body"
        close-on-popstate
        :close-on-click-overlay="false"
        :style="{ height: '95%' }">
        <div class="table-data-select-container">
          <div class="preview-container">
            <van-checkbox v-model="allValueSelect" @change="allValueSelectChange">全选</van-checkbox>
            <van-checkbox-group
              v-model="selectValues"
              ref="checkboxGroup">
              <van-checkbox
                v-for="item in valueStrList"
                :key="item.id"
                :name="item.id">
                {{item.value}}
              </van-checkbox>
            </van-checkbox-group>
          </div>
        </div>
        <div class="footer-handle-container">
          <div style="color: #2d8cf0; font-size: 12px;margin-right: 10px;">已选择{{selectValues.length}}条数据</div>
          <van-button type="default" @click="selectValuesCancel">取消</van-button>
          <van-button type="primary" @click="selectValuesConfirm">确定</van-button>
        </div>
      </van-popup>

      <!--子表单分组-->
      <van-popup
        class="table-group-popup"
        v-model="groupShow"
        position="bottom"
        get-container="body"
        close-on-popstate
        :style="{ height: '60%' }">

        <div class="table-group-container">
          <div class="table-group-header">
            <div>
              选择分组条件
            </div>
            <van-icon name="cross" @click="groupShow = false" />
          </div>
          <div
            class="table-group-item"
            v-for="(group, idx) in groupList"
            :key="group.groupFieldId">

            <div class="field-select" @click="onClickFieldSelect(group)">
              <div>
                {{dataId2FieldTitle(group.groupFieldId)}}
              </div>
              <svg viewBox="0 0 16 16" width="16" height="16" fill="#8C8C8C">
                <path d="M8 11c-.3 0-.5-.1-.7-.3l-4-4c-.4-.4-.4-1 0-1.4s1-.4 1.4 0L8 8.6l3.3-3.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-4 4c-.2.2-.4.3-.7.3z"
                ></path>
              </svg>
            </div>

            <el-radio-group v-if="group.groupFieldId" v-model="group.sort" size="small">
              <el-radio-button label="ASC">正序</el-radio-button>
              <el-radio-button label="DESC">倒序</el-radio-button>
            </el-radio-group>

            <div class="handel-btn" v-if="group.groupFieldId" >
              <el-button type="text" icon="el-icon-delete" @click="deleteGroup(group, idx)"></el-button>
            </div>
          </div>

          <van-action-sheet
            v-model="showFieldSelect"
            :actions="fieldsActions"
            cancel-text="取消"
            close-on-click-action
            get-container="body"
            @select="handleSelectField"
          />
        </div>
        <div class="footer-handle-container">
          <van-button type="default" @click="groupCancel">取消</van-button>
          <van-button type="primary" @click="groupConfirm">确定</van-button>
        </div>
      </van-popup>
    </template>

  </van-cell>
</template>

<script>
  import TableItem from './Table/table-item'
  import {current} from './mixin'
  import {
    FORM_ITEM__ATTACHMENT, FORM_ITEM__EXTERNAL_DATA_SOURCE,
    FORM_ITEM__IMAGE,
    FORM_ITEM__SIGNATURE,
    FORM_STATUS__READ,
    FORM_TYPE__FILL, PERMISSION__HIDDEN,
    SUCCESS
  } from "../types"
  import RyFormSet from "../index";
  import ScrollTable from "../../component/SryTable/ScrollTable";
  import CreateFormApply from "../../component/CreateFormApply";
  import {fetchFieldValue, isNull, isUndefined, clone} from "../../../assets/js/Untis";

  export default {
    mixins: [current],
    provide() {
      return {
        hasFillFormMap: this.hasFillFormMap,
        relateFormNameMap: this.relateFormNameMap
      }
    },
    data() {
      return {
        formSet: new RyFormSet(),
        FORM_STATUS__READ,
        allExpand: false,
        showList: [],
        showHandle: false,
        showData: false,
        finished: false,
        pageInfo: {
          currentPage: 0,
          pageSize: 50,
          totalPage: 0,
          totalCount: 0,
        },
        dataList: [],
        originDataList: [],
        selectList: [],
        allSelect: false,

        hasFillFormMap: {},
        relateFormNameMap: {},
        dataLoadConfig: {},

        initPer: false,
        hasFillForm: false,
        showSelectValues: false,
        selectValues: [],
        allValueSelect: false,

        groupShow: false,
        groupList: [],
        showFieldSelect: false,
        editGroup: null
      }
    },
    computed: {
      length() {
        return this.current.value.length
      },
      actions() {

        const arr = []
        if (!this.isReadOnly && !this.isRead) {
          if (!this.current.closeTableDelete) {
            arr.push({name: '添加记录', color: '#4260FA'})
          }
          if (this.current.openDataLoad === 'YES') {
            this.current.dataLoadList.forEach(item => {
              arr.push({name: item.buttonTitle, color: item.bgColor, item})
            })
          }
          if (this.current.quickGroup === 'YES' && this.current.value && this.current.value.length) {
            arr.push({
              id: 'quickGroup',
              name: `${this.current.quickGroupButton.buttonTxt} • (${this.validGroupIds.length})`,
              color: this.current.quickGroupButton.buttonColor
            })
          }
          if (this.current.openTableCreate === 'YES') {
            arr.push({
              id: 'createForm',
              name: this.current.startFormButton.buttonTxt,
              color: this.current.startFormButton.buttonColor
            })
          }
        }

        if ((this.current.showTableStyle === 'NO' || !this.isRead) &&
          this.current.value && this.current.value.length) {
          arr.push({name: this.allExpand ? '全部收起' : '全部展开'})
        }

        if (!this.isReadOnly && !this.isRead && this.current.value && this.current.value.length && !this.current.closeTableDelete) {
          arr.push({name: '清空子表单内容'})
        }
        return arr
      },
      subTableData() {

        let subTableData = {}
        if (this.current.showTableStyle === 'YES') {
          const formSet = this.current.root
          const xList = []
          const widthInfo = {}
          this.current.children.forEach(item => {
            if (this.isShow(item)) {
              xList.push({
                field_name: item.dataId,
                name: item.fieldTitle,
                type: item.type,
                colspan: 1,  //指定单元格 横向 跨越的 列数
                rowspan: 1, //指定单元格 纵向 跨越的 行数
              })

              const field = formSet.fields[item.dataId]
              if (field) {
                widthInfo[item.dataId] = field.width
              }
            }
          })

          const yList = []
          this.current.value.forEach(row => {

            const rowValObj = {}
            Object.keys(row).forEach(fieldId => {
              if (this.isShow(this.current.children.filter(item => item.dataId === fieldId)[0])) {
                const val = row[fieldId]
                if (this.current.children.map(field => field.dataId).includes(fieldId)) {
                  const field = this.current.children.filter(f => f.dataId === fieldId)[0]
                  let newVal = null
                  if ([FORM_ITEM__SIGNATURE, FORM_ITEM__IMAGE, FORM_ITEM__ATTACHMENT].includes(field.type)) {
                    newVal = val
                  } else {
                    newVal = formSet.valueToString(fieldId, val)
                  }

                  this.$set(rowValObj, fieldId, newVal)
                }
              }
            })
            yList.push(rowValObj)
          })

          this.$set(subTableData, 'xList', [xList])
          this.$set(subTableData, 'xField', this.current.children.map(field => field.dataId))
          this.$set(subTableData, 'yList', yList)
          this.$set(subTableData, 'widthInfo', widthInfo)
        }
        return subTableData
      },
      valueStrList() {
        const arrTemp = []
        if (!this.current.startFormInfo.createMap || !this.current.startFormInfo.createMap.length) {
          return arrTemp
        }
        const showFieldIds = this.current.startFormInfo.createMap.map(item => item.localFieldId)
        this.current.value.forEach(item => {
          const showData = {
            id: item.id,
            value: ''
          }

          this.current.children.forEach(h => {

            if (showFieldIds.includes(h.dataId)) {
              const val = fetchFieldValue({
                fieldType: h.type,
                value: item[h.dataId],
                dateType: h.dateType,
                dataType: h.dataType
              })
              if (!isNull(val) && !isUndefined(val) && val) {
                showData.value += `${val}-`
              }
            }
          })
          showData.value = showData.value.substr(0, showData.value.length - 1)
          arrTemp.push(showData)
        })
        return arrTemp
      },
      fieldsActions() {
        return this.current.children.map(field => {
          return {
            name: field.fieldTitle,
            dataId: field.dataId,
            disabled: this.groupList.map(f => f.groupFieldId).includes(field.dataId)
          }
        })
      },
      validGroupIds() {
        return this.groupList.filter(group => group.groupFieldId)
      }
    },
    created() {
      // if (this.length === 0) {
      //   this.current.addRow()
      // }
      // this.resetShowList()
      this.allExpand = this.current.allExpand
      if (this.current.allExpand) {
        this.current.value.forEach(item => {
          this.showList.push(item.id)
        })
      }

      this.current.children.forEach(item => {
        if (item.type === FORM_ITEM__EXTERNAL_DATA_SOURCE && item.relateAppId && item.relateFormId) {

          this.$store.dispatch('actionFormFillPermission', {
            appId: item.relateAppId,
            formId: item.relateFormId,
          }).then(res => {
            this.$set(this.hasFillFormMap, item.dataId, res.hasPer)
          }).catch(console.error)

          this.$store.dispatch('actionLiteMergeStructure', {
            appId: item.relateAppId,
            formId: item.relateFormId,
          })
            .then(res => {
              this.$set(this.relateFormNameMap, item.dataId, res.detailInfo.formName)
            })
            .catch(console.error)
        }
      })

      this.$store.dispatch('actionFormTableGroupGet', {
        companyId: this.current.root.companyId,
        formId: this.current.root.formId,
        tableId: this.current.dataId
      }).then(res => {
        this.groupList = res.groupList
        if (!this.groupList.length) {
          this.groupList.push({
            "groupFieldId":"",
            "sort":"ASC" //ASC 正序 DESC 倒序
          })
        }
      })
    },
    methods: {
      isShow(field) {
        if (!field) {
          return false
        }
        return !(field.permission === PERMISSION__HIDDEN || field.hidden === 1 || !field.displayInfo.show)
      },
      addItem() {
        this.current.addRow()
        this.controlChange()
        this.resetShowList()
      },
      removeItem(idx) {
        this.current.value.splice(idx, 1)
        this.controlChange()
      },
      resetShowList() {
        this.showList.splice(0, this.length)
        if (this.current.value.length > 0) {
          this.showList.push(
            this.current.value[this.length - 1].id
          )
        }
      },

      actionClearTableData() {
        this.$dialog.confirm({
          title: '确认信息',
          message: '确定清空表格内所有数据吗？',
          beforeClose: (action, done) => {
            if (action === 'confirm') {
              this.current.value.splice(0, this.current.value.length)
              this.controlChange()
            }
            done()
          }
        })
      },
      expandData() {
        this.showList.splice(0, this.showList.length)
        if (!this.allExpand) {
          this.current.value.forEach(item => {
            this.showList.push(item.id)
          })
        }
        this.allExpand = this.allExpand ? 0 : 1
      },

      handleSelect(action, index) {

        if (action.name === '添加记录') {
          this.addItem()
        } else if (action.name === '全部收起' || action.name === '全部展开') {
          this.expandData()
        } else if (action.name === '清空子表单内容') {
          this.actionClearTableData()
        } else if (action.id === 'quickGroup') {
          this.groupContentChange()
          this.groupShow = true
        } else if (action.id === 'createForm') {

          if (this.initPer) {
            if (this.hasFillForm) {
              this.showSelectValues = true
            } else {
              this.$toast.fail('您暂无权限发起表单，请联系管理员')
            }
          } else {
            const toast = this.$toast.loading()
            this.$store.dispatch('actionFormFillPermission', {
              appId: this.current.startFormInfo.appId,
              formId: this.current.startFormInfo.formId,
            }).then(res => {
              this.initPer = true
              this.hasFillForm = res.hasPer
              if (this.hasFillForm) {
                this.showSelectValues = true
              } else {
                this.$toast.fail('您暂无权限发起表单，请联系管理员')
              }
            }).catch(console.error)
              .finally(() => {
                toast.clear()
              })
          }

        } else {
          this.dataLoadConfig = action.item
          this.allSelect = false
          this.finished = false
          this.originDataList.splice(0, this.originDataList.length)
          this.selectList.splice(0, this.selectList.length)
          this.dataList.splice(0, this.dataList.length)
          this.pageInfo = {
            currentPage: 0,
            pageSize: 50,
            totalPage: 0,
            totalCount: 0,
          }
          this.showData = true
          this.onLoad()
        }

      },
      onLoad() {
        this.loading = true
        this.$store.dispatch('actionFormSubTableDataFetch', {
          formId: this.current.root.formId,
          tableId: this.current.dataId,
          key: this.dataLoadConfig.key,
          data: this.current.root.getValues(), //当前数据信息
          currentPage: this.pageInfo.currentPage + 1,
          pageSize: this.pageInfo.pageSize,
        })
          .then(res => {
            this.pageInfo.totalPage = res.pageData.totalPage
            this.pageInfo.currentPage = res.pageData.currentPage
            this.pageInfo.totalCount = res.pageData.totalCount
            if (res.pageData.totalPage <= res.pageData.currentPage) {
              this.finished = true
            }

            this.originDataList.push(...res.pageData.dataList)

            res.pageData.dataList.forEach(item => {
              const showData = {
                uniqueKey: item.uniqueKey,
                value: ''
              }

              res.headerList.forEach(h => {
                const val = fetchFieldValue({
                  fieldType: h.type,
                  value: item[h.dataId],
                  dateType: h.dateType,
                  dataType: h.dataType
                })
                if (!isNull(val) && !isUndefined(val) && val) {
                  showData.value += `${val}-`
                }
              })
              showData.value = showData.value.substr(0, showData.value.length - 1)
              this.dataList.push(showData)
            })
          }).catch(console.error)
          .finally(() => {
            this.finished = true
            this.loading = false
          })
      },
      allSelectChange() {
        if (this.allSelect) {
          this.selectList.splice(0, this.selectList.length, ...this.dataList.map(item => item.uniqueKey))
        } else {
          this.selectList.splice(0, this.selectList.length)
        }
      },
      selectCancel() {
        this.showData = false
      },
      selectConfirm() {

        const selectionList = []

        this.originDataList.forEach(item => {
          if (this.selectList.includes(item.uniqueKey)) {
            selectionList.push(item)
          }
        })

        const values = []
        if (this.dataLoadConfig.handleDataInfo.length) {
          selectionList.forEach(item => {
            const value = this.fieldSetData(this.dataLoadConfig.handleDataInfo, this.current, item)
            values.push(value)
          })
        }

        const valuesMap = {}
        this.dataLoadConfig.otherTableConfig.forEach(o => {
          if (o.handleDataInfo.length) {
            const tableField = this.current.root.fields[o.tableFieldId]
            const values = []
            selectionList.forEach(item => {
              const value = this.fieldSetData(o.handleDataInfo, tableField, item)
              values.push(value)
            })
            valuesMap[o.tableFieldId] = values
          }
        })

        if (this.dataLoadConfig.dataAddType === 'APPEND') {
          this.current.value.push(...values)
          // 其他子表单赋值
          Object.keys(valuesMap).forEach(key => {
            const values = valuesMap[key]
            const tableField = this.current.root.fields[key]
            tableField.value.push(...values)
          })
        } else if (this.dataLoadConfig.dataAddType === 'COVER') {
          this.current.value = values
          // 其他子表单赋值
          Object.keys(valuesMap).forEach(key => {
            const values = valuesMap[key]
            const tableField = this.current.root.fields[key]
            tableField.value = values
          })
        }

        this.showData = false

        if (this.dataLoadConfig.needRefreshData === 'YES') {
          this.submitTableData()
        }
      },

      fieldSetData(handleDataInfo, subTableField, originValues) {
        const value = subTableField.createValue()
        handleDataInfo.forEach(rule => {

          switch (rule.inputType) {
            case 'FIXED':
              this.$set(value, rule.localFieldId, rule.inputValue)
              break
            case 'NOW':
              this.$set(value, rule.localFieldId, new Date().getTime())
              break
            case 'RELATIVE_TIME':
              if (rule.relateType === -1) {
                // 之前
                this.$set(value, rule.localFieldId, new Date().getTime() - 86400000 * rule.days)
              } else if (rule.relateType === 1) {
                // 之后
                this.$set(value, rule.localFieldId, new Date().getTime() + 86400000 * rule.days)
              }
              break
            case 'CURRENT_USER':
              const fieldVal = value[rule.localFieldId]
              if (fieldVal && fieldVal.member) {
                fieldVal.member.push(this.$store.getters.userId)
              }
              break
            case 'CLEAR':
              this.$set(value, rule.localFieldId, null)
              break
            case 'FIELD_VALUE':
              this.$set(value, rule.localFieldId, originValues[rule.remoteFieldId])
              break
            default:
              break
          }
        })
        return value
      },

      submitTableData() {
        const requesting = Object.values(this.current.reqSerMap).some(item => item)
        if (requesting) {
          setTimeout(() => {
            this.submitTableData()
          }, 100)
        } else {
          const formSet = this.current.root
          const version = new Date().getTime()
          this.$store.dispatch('actionFormSubTableDataSubmit', {
            formId: formSet.formId,
            tableId: this.current.dataId,
            tmpTopic: formSet.tmpTopic,
            data: formSet.getValues(),
            version
          }).then(res => {
            formSet.lastSubmitTime = version
            formSet.submitMap[version] = {
              rowIdx: null,
              fieldId: this.current.dataId
            }
          }).catch(console.error)
        }
      },

      allValueSelectChange() {
        if (this.allValueSelect) {
          this.selectValues.splice(0, this.selectValues.length, ...this.current.value.map(item => item.id))
        } else {
          this.selectValues.splice(0, this.selectValues.length)
        }
      },
      selectValuesCancel() {
        this.showSelectValues = false
        this.selectValues.splice(0, this.selectValues.length)
      },
      selectValuesConfirm() {
        this.showSelectValues = false
        if (this.$refs.tableCreateFormApply) {
          this.$refs.tableCreateFormApply.onClickCreate()
        }
      },
      createFormComplete(formSet) {
        const tableData = this.current.value.filter(item => this.selectValues.includes(item.id))
        const data = clone(this.current.root.getValues())
        data[this.current.dataId] = tableData
        this.$store.dispatch('actionFormTableApplyData', {
          appId: this.current.root.appId,
          formId: this.current.root.formId,
          viewId: this.viewId,
          data,
          tableId: this.current.dataId
        }).then(res => {
          formSet.setValues(res)
          this.selectValues.splice(0, this.selectValues.length)
        }).then(() => {
          return this.$store.dispatch('actionFormDefaultSubmitData', {
            appId: formSet.appId,
            formId: formSet.formId,
            data: formSet.getValues()
          })
        }).then(res => {
          formSet.setValues(res)
        }).catch(console.error)
      },

      // 点击排序控件
      onClickFieldSelect(group) {
        this.editGroup = group
        this.showFieldSelect = true
      },
      // 选择完排序控件
      handleSelectField(item) {
        this.showFieldSelect = false
        this.editGroup.groupFieldId = item.dataId
        this.groupFieldIdChange()
      },
      dataId2FieldTitle(dataId) {
        const field = this.current.children.filter(item => item.dataId === dataId)[0]
        return field ? field.fieldTitle : ''
      },
      groupFieldIdChange() {
        if (this.groupList.length < 3 && !this.groupList.some(f => !f.groupFieldId)) {
          this.groupList.push({
            "groupFieldId":"",
            "sort":"ASC" //ASC 正序 DESC 倒序
          })
        }
      },
      groupCancel() {
        this.groupShow = false
      },
      groupConfirm() {
        this.groupContentChange()
        this.groupShow = false
      },
      deleteGroup(group,idx) {
        this.groupList.splice(idx, 1)
        if (!this.groupList.some(f => !f.groupFieldId)) {
          this.groupFieldIdChange()
        }
      },
      groupContentChange() {
        const formSet = this.current.root
        this.$store.dispatch('actionFormTableGroup', {
          appId: formSet.appId,
          formId: formSet.formId,
          data: formSet.getValues(),
          tableId: this.current.dataId,
          groupList: this.groupList
        }).then(res => {
          const value = res[this.current.dataId]
          if (value && value.length) {
            this.current.setValue(value)
          }
        }).catch(console.error)
      }
    },
    components: {
      TableItem,
      ScrollTable,
      CreateFormApply
    },
    watch: {}
  }
</script>

<style lang="less">
  .form-item-table-cell {
    padding: 0 !important;

    .van-cell__title {
      width: 100%;

      .title {
        background-color: #ffffff;
        position: relative;
        z-index: 100;
      }

      .van-cell__label {
        background-color: #ffffff;
        padding: 0 16px;
        margin-top: 0 !important;

        .table-row-container {
          -webkit-line-clamp: 200;
        }
      }
    }
  }

  .table-data-select-popup {
    .van-checkbox {
      padding: 10px;
      border-bottom: 1px solid #e6e6e6;

      .van-checkbox__label {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-wrap: break-word;
        font-size: 14px;
        color: #333333;
      }
    }

    .table-data-select-container {
      height: calc(100% - 40px);
      width: 100%;
      overflow: auto;

    }


    .footer-handle-container {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-top: 1px solid #e6e6e6;
      box-shadow: 0 2px 4px 0 rgba(43, 52, 65, 0.1);

      .van-button {
        margin-right: 20px;
        height: 30px;
      }
    }
  }

  .table-group-popup {

    .table-group-container {
      padding: 10px;
      width: 100%;
      height: calc(100% - 40px);
      overflow: auto;
      position: relative;

      .table-group-header {
        display: flex;
        justify-content: space-between;
        padding-top: 10px;
        height: 60px;

        > div {
          font-size: 16px;
        }

        i {
          cursor: pointer;
        }
      }

      .table-group-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;

        .field-select {
          margin-right: 10px;
          width: 120px;
          height: 38px;
          flex-shrink: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #f5f7fa;
          border-radius: 4px;
          padding: 12px 8px;

          >div {
            width: 120px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 12px;
          }
        }

        .handel-btn {
          display: flex;
          align-items: center;
          margin-left: 10px;

          .el-button {
            margin-left: 10px;
            margin-top: 0;
            color: red;
          }

          i {
            cursor: pointer;
          }
        }
      }
    }

    .footer-handle-container {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-top: 1px solid #e6e6e6;
      box-shadow: 0 2px 4px 0 rgba(43, 52, 65, 0.1);

      .van-button {
        margin-right: 20px;
        height: 30px;
      }
    }
  }
</style>